import isEmpty from './isEmpty'

export default function notEmpty (v) {
  return !isEmpty(v)
}
